import { Controller } from 'stimulus'

const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000

export default class extends Controller {
  static targets = ['days', 'unit']

  static values = {
    endDate: String,
  }

  connect() {
    this.update()
    this.timer = window.setInterval(() => this.update(), 60 * 1000)
  }

  disconnect() {
    if (this.timer) window.clearInterval(this.timer)
  }

  update(now = new Date()) {
    const days = this.daysRemaining(now)
    this.element.hidden = days <= 0

    if (this.hasDaysTarget) this.daysTarget.textContent = days.toString()
    if (this.hasUnitTarget) this.unitTarget.textContent = days === 1 ? ' day' : ' days'
  }

  daysRemaining(now = new Date()) {
    const endDate = this.parsedEndDate()
    if (!endDate) return 0

    const todayUtc = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate())
    const endUtc = Date.UTC(endDate.year, endDate.month - 1, endDate.day)

    return Math.max(0, Math.round((endUtc - todayUtc) / MILLISECONDS_PER_DAY))
  }

  parsedEndDate() {
    const match = this.endDateValue.match(/^(\d{4})-(\d{2})-(\d{2})$/)
    if (!match) return null

    return {
      year: Number(match[1]),
      month: Number(match[2]),
      day: Number(match[3]),
    }
  }
}
